import faker from 'faker';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useEffect, useRef, useState } from 'react';
import micFill from '@iconify/icons-eva/mic-fill';
import roundSend from '@iconify/icons-ic/round-send';
import attach2Fill from '@iconify/icons-eva/attach-2-fill';
import roundAddPhotoAlternate from '@iconify/icons-ic/round-add-photo-alternate';
import { isAdminUser } from '../../../utils/adminUserTypes';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Input, Divider, IconButton, InputAdornment, Stack, CircularProgress } from '@material-ui/core';
//
import EmojiPicker from '../../EmojiPicker';
import { ref as imageref, uploadBytesResumable,getDownloadURL } from '@firebase/storage';
import { storage } from 'src/firebase/firebase';
import { useSnackbar } from 'notistack';
import { supabase } from '../../../supabase/supabaseClient';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  minHeight: 56,
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  paddingLeft: theme.spacing(2)
}));

// ----------------------------------------------------------------------

JobNoteMessageInput.propTypes = {
  disabled: PropTypes.bool,
  conversationId: PropTypes.string,
  onSend: PropTypes.func
};

export default function JobNoteMessageInput({ disabled,conversatingUser,addedBy, conversationId, onSend,adminData,fromDesign,requestIdd,designOrderId,isDesignOrder,jobCostNote,convertedDesignRequestId, noteType, ...other }) {
  console.log('conversatingUserconversatingUser',conversatingUser)
  console.log('JobNoteMessageInput - designOrderId:', designOrderId)
  console.log('JobNoteMessageInput - isDesignOrder:', isDesignOrder)
  console.log('JobNoteMessageInput - requestIdd:', requestIdd)
  let user = JSON.parse(localStorage.getItem('user'))
  const requestId = requestIdd || localStorage.getItem('requestId')
  const userType=user.user_type
  const userId=user.user_id
  const fileInputRef = useRef(null);
  const [selectedFileName, setSelectedFileName] = useState('')
  const [message, setMessage] = useState('');
  const [image,setImage] = useState('')
  const [progress,setProgress] = useState(false)
  const { enqueueSnackbar } = useSnackbar();
  const inputRef = useRef(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleAttach = () => {
    fileInputRef.current.click();
  };
  // const handleFileChange = async (event) => {
  //   const file = event.target.files[0];
  //    console.log(file,'-----------files')
  //    setSelectedFileName(file?.name)
  //    const Filename = new Date().getTime() + file?.name;

  //     const StorageRef = imageref(storage, Filename);
  //     const uploadTask = uploadBytesResumable(StorageRef, file);

  //     uploadTask.on(
  //       'state_changed',
  //       (snapshot) => {
  //         const pro = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
  //         setProgress(true)
  //       },
  //       (error) => {
  //         console.error(error.message);
  //         setProgress(false)   
  //         enqueueSnackbar('Please upload image less than 1 GB', { variant: 'error' });
  //       },
  //       () => {
  //         getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //          console.log(downloadURL,'-------------downloadURL')    
  //          setImage(downloadURL)
  //          setProgress(false)   
  //         });
  //       }
  //     );
  // }

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    console.log(file, '-----------files');
    setSelectedFileName(file.name);

    const timestamp = Date.now();
    const sanitizedFileName = file.name.replace(/\s+/g, '_');
    const filename = `${timestamp}_${sanitizedFileName}`;
    const filePath = `job-note/attachments/${filename}`;

    try {
      setProgress(true);

      const { error: uploadError } = await supabase.storage
        .from('signwise-attachments')
        .upload(filePath, file);

      if (uploadError) {
        throw uploadError;
      }

      const { data: publicUrlData, error: urlError } = supabase.storage
        .from('signwise-attachments')
        .getPublicUrl(filePath);

      if (urlError || !publicUrlData?.publicUrl) {
        throw new Error('Failed to get public URL');
      }

      console.log(publicUrlData.publicUrl, '-------------downloadURL');
      setImage(publicUrlData.publicUrl);
    } catch (error) {
      console.error(error.message);
      enqueueSnackbar('Please upload image less than 1 GB', { variant: 'error' });
    } finally {
      setProgress(false);
    }
  };

  const handleChangeMessage = (event) => {
    setMessage(event.target.value);
  };

  // const handleKeyUp = (event) => {
  //   if (event.key === 'Enter' || event.keyCode === 13) {
  //     handleSend();
  //   }
  // };
  const isDesignNotes = noteType === 'design' || fromDesign;

  const handleKeyUp = (event) => {
  if (event.key === 'Enter' || event.keyCode === 13) {
    const canSend = 
      (message || image) &&
      (isDesignNotes || conversatingUser?.length > 0) &&
      !progress;

    if (canSend) {
      handleSend();
    }
  }
};

 
//   const handleSend = () => {
//     if (!message&&!image) {
//       return '';
//     }
//     if (onSend) {
//       onSend({
//         userId:userId,
//         requestId:requestId,
//         isVendor:user.isVendor,
//         msg: message,
//         contentType: 'text',
//         image:image,
//         createdAt: new Date(),
//         to:userType != 3 ? conversatingUser?.id : (adminData?.id || addedBy),
//         userType:userType,
//         from_status:fromDesign ? 1 : 2
//       });
//     }
//             setImage('');
//             setSelectedFileName('')
//     return setMessage('');
     
//   };

const handleSend = () => {
  console.log('handleSend---image', image)
  console.log('handleSend---message', message)
  
  if (!message && !image) return;
    let recipientIds;

  if (userType === 3) {
    // Client sending message to admin
    recipientIds = [(adminData?.user_id || addedBy)];
  } else if (isDesignNotes) {
    // Design Notes: no To required — use members if present, otherwise admin
    recipientIds =
      conversatingUser?.length > 0
        ? conversatingUser.map((recipient) => recipient.user_id)
        : [(adminData?.user_id || addedBy)];
  } else {
    console.log('conversatingUser', conversatingUser)
    if (!conversatingUser || conversatingUser.length === 0) return;
    recipientIds = conversatingUser.map((recipient) => recipient.user_id);
  }
  if (onSend) {
      // Determine from_status based on noteType prop
      let fromStatus;
      if (noteType === "design") {
        fromStatus = 1; // Design notes
      } else if (noteType === "job") {
        fromStatus = 2; // Job notes
      } else {
        // Fallback to original logic
        fromStatus = fromDesign ? 1 : 2;
      }
      
      // If designOrderId exists and isDesignOrder is false, this request was converted from a design order
      // In this case, we need to pass the current requestId as converted_design_request_id
      const isConvertedFromDesignOrder = designOrderId && !isDesignOrder;
      
      const sendData = {
        userId: userId,
        requestId: isDesignOrder ? null : requestId,
        designOrderId: designOrderId || null,
        converted_design_request_id: isDesignOrder ? convertedDesignRequestId : (isConvertedFromDesignOrder ? requestId : null),
        isVendor: user.isVendor,
        msg: message,
        contentType: 'text',
        image: image,
        createdAt: new Date(),
        to: recipientIds,
        userType: userType,
        from_status: fromStatus
      };
      
      console.log('JobNoteMessageInput - sendData:', sendData);
      onSend(sendData);
  }

  setImage('');
  setSelectedFileName('');
  setMessage('');
};

  return (
    <RootStyle {...other}>
      <Input
       inputRef={inputRef} 
        disabled={disabled}
        fullWidth
        value={message}
        disableUnderline
        onKeyUp={handleKeyUp}
        onChange={handleChangeMessage}
        placeholder={"Type here"}
        startAdornment={
          <InputAdornment position="start">
                   {image && (
                      <img src={image} alt="Attached Image" style={{ maxWidth: '50px', maxHeight: '50px', marginLeft: '10px' }} />
                    )}
            {/* <EmojiPicker disabled={disabled} value={message} setValue={setMessage} /> */}
          </InputAdornment>
        }
        endAdornment={
          <Stack direction="row" alignItems='center' spacing={0.5} mr={1.5}>
            <IconButton disabled={disabled} sx={{color:jobCostNote ? "common.white" : "text.disabled"}} size="small" onClick={handleAttach}>
              <Icon icon={roundAddPhotoAlternate} width={24} height={24} />
            </IconButton>
            {/* <IconButton disabled={disabled} size="small" onClick={handleAttach}>
              <Icon icon={attach2Fill} width={24} height={24} />
            </IconButton> */}
            {/* <IconButton disabled={disabled} size="small">
              <Icon icon={micFill} width={24} height={24} />
            </IconButton> */}
            <EmojiPicker disabled={disabled} value={message} setValue={setMessage} jobCostNote={jobCostNote} /> 
          </Stack>
        }
        sx={{
          height: '100%',
          '& .MuiInputBase-input::placeholder': {
            color: jobCostNote ? '#ccc' : 'text.disabled',
            opacity: 1, // ensure placeholder is fully visible
          },
        }}
      />

      <Divider orientation="vertical" flexItem />

      {/* {
      isAdminUser (userType) ? (
         conversatingUser?.length > 0 && (
           <IconButton color="primary" disabled={!message&&!image} onClick={handleSend} sx={{ mx: 1 }}>
            {progress?
            (
              <CircularProgress sx={{width:24,height:24}} color="secondary"
              variant="indeterminate"/>
            ):(
             <Icon icon={roundSend} width={24} height={24} />
             )}
             </IconButton>
             )
        ) : (
           (
           <IconButton color="primary" disabled={!message&&!image} onClick={handleSend} sx={{ mx: 1 }}>
             {progress?
            (
              <CircularProgress sx={{width:24,height:24}} color="secondary"
              variant="indeterminate"/>
            ):(
             <Icon icon={roundSend} width={24} height={24} />
             )}
           </IconButton>
           )
         )
         } */}
         <IconButton
            color="primary"
            disabled={
              (!message && !image) ||
              (!isDesignNotes && (!conversatingUser || conversatingUser.length === 0)) ||
              progress
            }
            onClick={handleSend}
            sx={{ mx: 1 }}
          >
            {progress ? (
              <CircularProgress sx={{ width: 24, height: 24, color:jobCostNote ? "common.white" : "text.disabled" }} variant="indeterminate" />
            ) : (
              <Icon icon={roundSend} width={24} height={24} sx={{ color: jobCostNote ? "common.white" : "text.disabled" }} />
            )}
          </IconButton>
         
       <input type="file" ref={fileInputRef}  onChange={handleFileChange} style={{ display: 'none' }} />
    </RootStyle>
  );
}
